import ProductCategoryList from './ProductCategoryList'
export {ProductCategoryList}
export default ProductCategoryList
